module.exports = __webpack_public_path__ + "static/media/HomeHeroDashboard.929e5ee2.png";